<template>
  <div>
    <div class="d-flex align-center flex-wrap">
      <v-slide-x-transition
        group
        tag="v-sheet"
        style="background: transparent"
        class="d-flex items-end"
      >
        <v-sheet
          v-for="(post, index) in room.posts"
          :key="`post-${index}`"
          elevation="5"
          style="border-radius: 8px"
          width="60px"
          height="80px"
          class="post pointer mr-1"
          @click="show(post)"
        >
          <div v-if="post.images.length">
            <v-img
              :lazy-src="post.images[0].url"
              :src="post.images[0].url"
              aspect-ratio="1"
              style="border-radius: 8px"
            ></v-img>
          </div>
          <div class="px-1 py-0 text-truncate caption">
            <small
              v-if="post.title"
              class="text--secondary"
              v-html="post.title"
            ></small>
          </div>
        </v-sheet>
      </v-slide-x-transition>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import { Component, Vue } from 'vue-property-decorator'

@Component({
  components: {
    Post: () => import(/* webpackPrefetch: true */ '@/views/room/components/post/show/Index.vue')
  },
  props: {
    room: {
      type: Object,
      default: null
    },
    customer: {
      type: Object,
      default: null
    }
  }
})
export default class Index extends Vue {
  data () {
    return {
      posts: {
        selected: {
          item: null,
          visible: false
        }
      }
    }
  }

  setCustomer () {
    this.$emit('setCustomer')
  }
  
  show (post) {
    this.posts.selected.visible = true
    this.posts.selected.item = post
    this.$emit('showPost', this.posts.selected)
  }
}
</script>

<style>
  .post:first-child {
    margin-left: 0px;
  }

  .post {
    border: 1px solid transparent;
    transition: all 0.2s;
  }

  .post:hover {
    border: 1px solid #204def;
  }
  .items-end{
    align-items: end !important;
  }
</style>
